import { Component, OnInit, Inject } from '@angular/core';
import { FleetService } from '../../../services/fleet/fleet.service';
import { TripService } from '../../../services/trip/trip.service';
import { ResourceService } from '../../../services/resource/resource.service';
import { OrderService } from '../../../services/order/order.service';
import { ProductserialnoService } from '../../../services/productserialno/productserialno.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MessagesService } from '../../../services/messages/messages.service';

import {
  MatDialog, MatDialogRef, MAT_DIALOG_DATA
} from '@angular/material';
import { TokenStorage } from 'src/app/auth/token.storage';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-edittripmodal',
  templateUrl: './edittripmodal.component.html',
  styleUrls: ['./edittripmodal.component.scss']
})
export class EdittripmodalComponent implements OnInit {
  serialNoForm: FormGroup;
  myControl = new FormControl();

  temSerialno = [];
  productIdArray = [];
  ungroupedserialNo = [];
  productIdContainer = [];
  productIdonly = [];
  public lat: Number = 18.552307
  public lng: Number = 73.724519

  public origin: {}
  public destination: {}
  public zoom: number = 13;
  public waypoints: any = []
  public productArrayInSelectedOrder = [];
  public productDetailsArray = [];

  whenselectedSerialNo: any;
  autoSerialNo: string;
  tripName: string;
  helperName: string;
  columnsToDisplay = [
    'zone',
    'origin',
    'destination',
    'orders',
    'transpoter',
    'vehicleType',
    'capacityUtilization',
  ];

  DRSColumnsTodisplay = [
    'check',
    'invoice',
    'receiverAddress',
    'productDetails',
    'deliverySequence'
  ];
  tripsDataArray = [];
  ordersByTripIdArray = [];
  //vehicle
  vehicleArray = [];
  selectedSerialNumbersForOrder = [];
  selectedVehicle: any;
  vehicleType: string;
  transporter: string;
  volumeCapacity: string;
  weightCapacity: string;

  isdataloaded: boolean = false;

  fleetSelectedForTrip: any;
  driverSelectedForTrip: any;

  driverArray = [];
  helperArray = [];
  driverData: any;
  fleetData: any;
  driverName: string;
  driverPhoneNo: string;
  driverLicenseNo: string;
  selectedDriver: number;
  accepted: boolean = false;

  newTripGetByIDArray = [];
  tripID: number;
  newDataOrderByIdArray = [];
  productInputDisplayArray = [];
  selectedFleet: string;
  productSerialNo = [];
  productsWidthSerialNo = [];
  isdriverExist: boolean = false;
  isFleetSelected: boolean = false;
  isDriverSelected: boolean = false;
  showSnackBarifDataExist: boolean = false;
  isDisabled: boolean = false;
  productId = [];
  productSerialNoToSend = [];
  finalProductSerialNo = [];
  assignedSerialNo = [];

  selectedSerialNO = [];
  selectedSerialQty: any;
  ifselectQtyDisable: boolean = false;
  alreadySelectedSerialNumbers = [];
  isSelect = [];


  customCollapsedHeight: string = '35px';
  customExpandedHeight: string = '35px';

  config = {
    search: true,
    displayKey: 'driverName',
    searchOnKey: 'driverName',
    height: '40vh',
    placeholder: 'Select Driver',
    clearOnSelection: true
  }

  configHelper = {
    search: true,
    displayKey: 'driverName',
    searchOnKey: 'driverName',
    height: '40vh',
    placeholder: 'Select Helper',
    clearOnSelection: true
  }

  configVehicle = {
    search: true,
    displayKey: 'vln',
    searchOnKey: 'vln',
    height: '40vh',
    placeholder: 'Select Vehicle',
    clearOnSelection: true
  }

  isKohinoor: boolean = false;
  shouldTripRefresh: boolean = false;
  constructor(@Inject(MAT_DIALOG_DATA)
  private data: any,
    private fleetService: FleetService,
    private tripService: TripService,
    private resourceService: ResourceService,
    private orderService: OrderService,
    private router: Router,
    private messagesService: MessagesService,
    private dialog: MatDialog,
    token: TokenStorage,
    private spinner: NgxSpinnerService,
    private notifierService: NotifierService
  ) {
    this.tripID = this.data.data.tripId
    console.log(this.data.data);
    if (this.data.data.helperName)
      this.helperName = this.data.data.helperName;
    if (token.getTenant() == 'kohinoor-reta-prod')
      this.isKohinoor = true;
  }

  ngOnInit() {
    this.spinner.show();
    this.zoom = 13;
    this.origin = { lat: 18.544405, lng: 73.735341 }
    this.destination = { lat: 18.544405, lng: 73.735341 }
    this.waypoints = [
      {
        location: "18.532667,73.8276983"
      },
      {
        location: "18.533654,73.8235143"
      },
      {
        location: "18.523258, 73.762949"
      }
    ]

    //save already assigned serial numbers for further operation
    this.alreadySelectedSerialNumbers = this.selectedSerialNO;
    this.selectedSerialNumbersForOrder = this.alreadySelectedSerialNumbers;

    console.log(this.productSerialNo);

    this.tripService.getOrdersTripById(this.tripID).subscribe(orders => {
      console.log("orders:", orders)
      this.ordersByTripIdArray = orders;
      this.getAllProductsFromOrdersInTrip();
    })

    this.tripService.getTripById(this.tripID).subscribe(res => {
      console.log(res);
      this.tripName = res.tripName;
      this.tripsDataArray = [res]

      if (res.fleet != null) {
        this.isFleetSelected = true;
        this.selectedVehicle = { vln: res.fleet.vehicleLicenseNumber, id: res.fleet.fleetId };
        this.vehicleType = res.fleet.vehicleType;
        if (res.fleet.transporter)
          this.transporter = res.fleet.transporter.transporterName;
        this.volumeCapacity = res.fleet.bodyVolumetricCapacity;
        this.weightCapacity = res.fleet.bodyWeightCapacity
        console.log(this.selectedFleet);
        if (res.fleet.preferedDriver != null) {
          let preferedDriver = res.fleet.preferedDriver;
          this.isDriverSelected = true;
          this.selectedDriver = preferedDriver.resourceId;
          let name;
          name = preferedDriver.firstName ? preferedDriver.firstName + " " : '';
          name += preferedDriver.lastName ? preferedDriver.lastName : '';
          this.driverName = name;
          this.driverPhoneNo = preferedDriver.phoneNumber1;
          this.driverLicenseNo = preferedDriver.driverLicenseNumber
        }
      }

      if (res.driver != null) {
        this.isDriverSelected = true;
        console.log(res.driver.resourceId);
        this.selectedDriver = res.driver.resourceId;
        this.driverPhoneNo = res.driver.phoneNumber1;
        let name;
        name = res.driver.firstName ? res.driver.firstName + " " : '';
        name += res.driver.lastName ? res.driver.lastName : '';
        this.driverName = name;
        this.driverLicenseNo = res.driver.driverLicenseNumber
      }
    }, () => {
      this.spinner.hide();
      this.notifierService.notify('error', 'Error in fetching orders.')
    })

    //fleet details
    if (!window.sessionStorage.getItem('activeVehicles')) {
      this.fleetService.getActiveFleets().subscribe(res => {
        this.vehicleArray = [];
        this.fleetData = res;
        for (let i = 0; i < res.length; i++) {
          let fleet = res[i].vehicleLicenseNumber;
          //let vln = {};
          this.vehicleArray.push({
            vln: res[i].vehicleLicenseNumber,
            id: res[i].fleetId
          });
        }
        this.vehicleArray.sort(function (a, b) {
          let vehicle1, vehicle2;
          if (a.vln)
            vehicle1 = a.vln.toLowerCase();
          if (b.vln)
            vehicle2 = b.vln.toLowerCase();
          if (vehicle1 < vehicle2) //sort string ascending
            return -1
          if (vehicle1 > vehicle2)
            return 1
          return 0
        })
        console.log("vehicles:", this.vehicleArray);

        window.sessionStorage.setItem('activeVehicles', JSON.stringify(this.vehicleArray))
        console.log("fleets by type and status:", res);
      }, Error => {
        console.log(Error);
        this.spinner.hide();
        this.notifierService.notify('error', 'Error in fetching fleets.')
      })
    }
    else {
      this.vehicleArray = JSON.parse(window.sessionStorage.getItem('activeVehicles'))
    }
    if (!window.sessionStorage.getItem('activeResources')) {
      this.resourceService.getAllAvailableResources().subscribe(res => {
        this.driverData = res;
        console.log(res)
        this.driverArray = []
        this.helperArray = [];
        for (let i = 0; i < res.length; i++) {

          let name;
          name = res[i].firstName ? res[i].firstName + " " : '';
          name += res[i].lastName ? res[i].lastName : '';
          this.driverArray.push({
            driverName: name,
            resourceId: res[i].resourceId,
            phoneNumber1: res[i].phoneNumber1,
            driverLicenseNumber: res[i].driverLicenseNumber

          });
        }
        this.driverArray.sort(function (a, b) {
          let driverName1, driverName2
          if (a.driverName)
            driverName1 = a.driverName.toLowerCase()
          if (b.driverName)
            driverName2 = b.driverName.toLowerCase()
          if (driverName1 < driverName2)
            return -1
          if (driverName1 > driverName2)
            return 1
          return 0
        });
        this.helperArray = this.driverArray;
        window.sessionStorage.setItem('activeResources', JSON.stringify(this.driverArray))
        console.log("available drivers", this.driverArray);

      }, Error => {
        console.log(Error);
        this.spinner.hide();
        this.notifierService.notify('error', 'Error in fetching drivers.')
      });
    }
    else {
      this.driverArray = JSON.parse(window.sessionStorage.getItem('activeResources'))
      this.helperArray = this.driverArray;
    }
  }

  vehicleSelected() {
    console.log(this.selectedVehicle)
    if (this.selectedVehicle) {
      this.spinner.show();
      /*     let fleetDetails = this.fleetData;
          for (let i = 0; i < fleetDetails.length; i++) {
            let allLicense = fleetDetails[i].vehicleLicenseNumber;
            if (allLicense == this.selectedVehicle.vln) {
              this.fleetSelectedForTrip = fleetDetails[i];
              this.vehicleType = fleetDetails[i].vehicleType;
              if (fleetDetails[i].transporter != null && fleetDetails[i].transporter.transporterName != null)
                this.transporter = fleetDetails[i].transporter.transporterName;
              else
                this.transporter = 'Not Assigned';
              this.volumeCapacity = fleetDetails[i].bodyVolumetricCapacity || 'Not Assigned';
              this.weightCapacity = fleetDetails[i].bodyWeightCapacity || 'Not Assigned';
              //this.preferedDriver();
            } else {
            }
          } */

      this.tripService.assignFleetToTrip(this.data.data.tripId, this.selectedVehicle.id).subscribe(res => {
        this.shouldTripRefresh = true;
        this.spinner.hide();
        this.isFleetSelected = true;
        console.log(res);
      }, Error => {
        this.spinner.hide();
        this.isFleetSelected = false;
        console.log(Error);
      })
    }
  }


  preferedDriver() {
    if (this.isFleetSelected || this.selectedVehicle != null) {
      console.log("fleet selected for trip:", this.fleetSelectedForTrip);
      let preferedDriver = this.fleetSelectedForTrip.preferedDriver;
      console.log(preferedDriver);
      if (preferedDriver != null) {
        this.isDriverSelected = true;
        this.selectedDriver = preferedDriver.resourceId;
        let name;
        name = preferedDriver.firstName ? preferedDriver.firstName + " " : '';
        name += preferedDriver.lastName ? preferedDriver.lastName : '';
        this.driverName = name;
        this.driverPhoneNo = preferedDriver.phoneNumber1;
        this.driverLicenseNo = preferedDriver.driverLicenseNumber
      } else {
        this.isDriverSelected = false;
        this.selectedDriver = undefined;
        this.driverName = "";
        this.driverPhoneNo = "";
        this.driverLicenseNo = ""
      }
    }
  }

  driverSelected(currentSelectedDriver, helperOrDriver) {
    console.log(currentSelectedDriver)
    if (currentSelectedDriver) {
      this.shouldTripRefresh = true;
      this.selectedDriver = currentSelectedDriver.resourceId;
      this.driverName = currentSelectedDriver.driverName
      this.driverPhoneNo = currentSelectedDriver.phoneNumber1;
      this.driverLicenseNo = currentSelectedDriver.driverLicenseNumber
      /* console.log(this.selectedDriver);
      let selectD = this.selectedDriver.toString();
      for (let i = 0; i < this.driverData.length; i++) {
        if (this.driverData[i].resourceId === parseInt(selectD)) {
          console.log(this.driverData[i]);
          this.driverSelectedForTrip = this.driverData[i];
          let name;
          name = this.driverData[i].firstName ? this.driverData[i].firstName + " " : '';
          name += this.driverData[i].lastName ? this.driverData[i].lastName : '';
          if (helperOrDriver == 'driver')
            this.driverName = name;
          else if (helperOrDriver == 'helper')
            this.helperName = name;
          this.driverPhoneNo = this.driverData[i].phoneNumber1;
          this.driverLicenseNo = this.driverData[i].driverLicenseNumber 
        }
      }*/
      if (helperOrDriver == 'driver') {
        this.tripService.assignDriverToTrip(this.data.data.tripId, this.selectedDriver).subscribe(res => {
          this.isDriverSelected = true;
          console.log(res);
        }, Error => {
          this.isDriverSelected = false;
          console.log(Error);
        });
      }
      else if (helperOrDriver == 'helper') {
        this.tripService.assignHelperToTrip(this.data.data.tripId, this.selectedDriver).subscribe(res => {
          console.log(res);
        }, Error => {
          console.log(Error);
        });
      }
    }

  }

  tabChanged(Event) {
    console.log(Event.index);
  }

  getAllProductsFromOrdersInTrip() {
    if (this.ordersByTripIdArray != null) {
      for (let i = 0; i < this.ordersByTripIdArray.length; i++) {
        console.log(this.ordersByTripIdArray);
        this.orderService.getAllProductsInOrder(this.ordersByTripIdArray[i].orderUniqueId).subscribe(res => {
          for (let j = 0; j < res.length; j++) {
            this.productArrayInSelectedOrder.push({
              productQuantity: res[j].productQuantity,
              orderId: this.ordersByTripIdArray[i].orderUniqueId,
              productName: res[j].product.productName
            });
          }
          this.spinner.hide();
          this.isdataloaded = true;
          console.log("products", this.productArrayInSelectedOrder);
        }, Error => {
          this.spinner.hide();
          console.log(Error);
        })
      }
    }
  }

  // getMyProperty() {
  //   return ["03w3ppcj300373", "03W3PPCJ300326", "03w3ppcj300211", "03w3ppcj300376", "03w3ppcj300211", "03w3ppcj300373"];
  // }
  compareByReference(o1: any, o2: any) {
    return o1 === o2;
  }

  compareObjectsByValue(d1: string, d2: string) {
    return d1 && d2 && d1 === d2;
  }

  orderCheckBox(orderId, tripId) {

    console.log("Deleting Order From Trip with Trip Id = " + tripId + "Order Id =" + orderId);

    const dialogRef = this.dialog.open(DialogConfirm, {
      width: '300px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        this.deleteOrderFromTrip(orderId, tripId);
        this.dialog.getDialogById('editTripModal').close(true);
      }
      console.log('The dialog was closed');
    });
  }

  ScheduleTrip() {
    console.log("Accept pressed " + this.data.data.tripId);
    this.spinner.show();
    this.tripService.scheduleTrip(this.data.data.tripId).subscribe(res => {
      console.log(res);
      this.spinner.hide();
      this.dialog.getDialogById('editTripModal').close(true)
      this.router.navigate(['/scheduling/scheduletrips']);
      this.messagesService.sendMessage("Trip # " + this.tripName + " accepected and scheduled succefully")
    }, Error => {
      this.spinner.hide();
      this.dialog.closeAll();
      console.log(Error);
    })

  }
  openDialog() {
    const dialogR = this.dialog.open(DeleteDialogConfirm, {
      width: '300px',
    });

    dialogR.afterClosed().subscribe(result => {
      if (result) {
        this.DeleteTrip();
      }
    });
  }

  DeleteTrip() {
    console.log("Delete pressed " + this.data.data.tripId);
    this.spinner.show();
    this.tripService.deleteTrip(this.data.data.tripId).subscribe(() => {
      this.spinner.hide();
      this.dialog.closeAll();
      this.messagesService.sendMessage("Trip # " + this.tripName + "deleted succefully")
    }, Error => {
      this.spinner.hide();
      console.log(Error);
    })
  }

  deleteOrderFromTrip(orderId, tripId) {
    this.spinner.show();
    this.tripService.deleteOrderFromTrip(orderId, tripId).subscribe(res => {
      this.spinner.hide();
      console.log(res);
      this.messagesService.sendMessage("Order with id " + orderId + " deleted from Trip " + tripId);
    }, Error => {
      this.spinner.hide();
      console.log(Error);
    })
  }
}

export interface OrderListElement {
  zone: string;
  tripID: string;
  origin: string;
  destination: string;
  orders: string;
  transpoter: string;
  vehicleType: string;
  capacityUtilization: string;
  status: string;
}

export interface tripElement {
  receiverName: string;
  invoice: string;
  productDetails: string;
  numOfProducts: string;
  serialNo: any;
}



@Component({
  selector: 'dialog-confirm',
  template: `
  <div style="padding:20px;">
  <p *ngIf='isDialogConfirm; else other'>{{data}}</p>
  <ng-template #other>
    <p> Are you sure you want to remove this order from trip ?</p>
    </ng-template>
    <div class="row">
   
     <div class="col">
        <button mat-raised-button color="primary" [mat-dialog-close]="true">OK</button>
     </div>
      <div class="col">
        <button mat-raised-button color="warn" (click)="onNoClick()">Cancel</button>
      </div>
     
    </div>
  </div>
  `,
})
export class DialogConfirm {

  isDialogConfirm: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<DialogConfirm>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    if (this.data)
      this.isDialogConfirm = true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}


@Component({
  selector: 'delete-dialog-confirm',
  template: `
  <div style="padding:20px;">
    <p> Are you sure you want to delete this trip ?</p>
    <div class="row">
      <div class="col">
        <button mat-raised-button color="warn" (click)="onNoClick()">NO</button>
      </div>
      <div class="col">
        <button mat-raised-button color="primary" [mat-dialog-close]="true">YES</button>
      </div>
    </div>
  </div>
  `,
})
export class DeleteDialogConfirm {


  constructor(
    public dialogR: MatDialogRef<DeleteDialogConfirm>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogR.close();
  }

}